module.exports = __webpack_public_path__ + "img/nf.88b1fa6a.png";